import { z } from "zod";

import { defaultItem, itemSchema } from "../shared";

// Schema
export const mostProudOfSchema = itemSchema.extend({
  name: z.string().min(1),
  description: z.string().default(""),
  icon: z.string().default("trophy2"),
});

// Type
export type MostProudOf = z.infer<typeof mostProudOfSchema>;

// Defaults
export const defaultMostProudOf: MostProudOf = {
  ...defaultItem,
  name: "",
  description: "",
  icon: "trophy2",
};
